import { exportArrayToCsv } from '@/lib/csvExport';
import { METRICS } from './fmt';

/** All operations in one CSV: one row per staff per operation, with month columns. */
export const exportRankingsCsv = (data) => {
  const metric = data.rank_by;
  const short = METRICS[metric].short;
  const rows = (data.operations || []).flatMap((o) => o.rows.map((r) => ({ ...r, op: o.name, module: o.module })));
  const cols = [
    ['op', 'Operation'], ['module', 'Section'], ['rank', 'Rank'], ['staff_id', 'Staff ID'], ['staff_name', 'Staff Name'], ['section', 'Staff Section'],
    ['days', 'Days Present'], ['hours', 'Hours'], [(r) => (r.hours_est ? 'Yes' : ''), 'Hours Estimated'], ['qty', 'Pieces'],
    ['per_day', 'Pcs / Day'], ['per_hour', 'Pcs / Hour'], ['target_pct', '% of Target'], ['vs_avg_pct', 'vs Op Avg %'],
    ...(data.months || []).flatMap((m) => [
      [(r) => r.months[m.key]?.value ?? '', `${m.label} ${short}`],
      [(r) => r.months[m.key]?.high?.value ?? '', `${m.label} High Day`],
      [(r) => r.months[m.key]?.low_day?.value ?? '', `${m.label} Low Day`],
      [(r) => (r.months[m.key]?.low ? 'LOW' : ''), `${m.label} Low?`],
    ]),
    ['low_months', 'Low Months'], ['max_low_streak', 'Longest Low Streak'], [(r) => (r.repeat_low ? 'YES' : ''), 'Repeat Low Performer'],
  ].map(([key, header]) => ({ key, header }));
  const sh = (data.shifts || []).find((s) => s.id === data.shift);
  const tag = [sh && sh.name.toLowerCase(), data.base_section && data.base_section !== 'all' && data.base_section].filter(Boolean).join('_');
  exportArrayToCsv(rows, cols, `staff_rankings_${data.date_from}_to_${data.date_to}_${metric}${tag ? `_${tag}` : ''}.csv`);
};

export default exportRankingsCsv;
